import {Navigate} from "react-router"

import {Loading} from "../components/Loading"
import {useSaaSCompanyOnboardingStatusQuery} from "../queries/saasCompany.ts"
import {useUserSettingsQuery} from "../queries/user.ts"
import {AUserTypes} from "../services/types.generated"
import {isSaaSCompanyUser} from "../utils/types.ts"

const Landing = () => {
  const {data, isPending} = useUserSettingsQuery()
  const user = data?.user
  const type = user?.type
  const isSaaSCompanyUserOnboarding = user ? isSaaSCompanyUser(user) && user.enabled_onboarding_screen : false
  const {data: onboardingStatus, isPending: isOnboardingStatusPending} = useSaaSCompanyOnboardingStatusQuery({
    enabled: isSaaSCompanyUserOnboarding,
  })

  if (isPending) {
    return <Loading size={"xl"} />
  }
  if ([AUserTypes.SalesPerson, AUserTypes.CompanyUser, AUserTypes.SaasSalesPerson].includes(type!)) {
    return <Navigate replace to={"/dashboard"} />
  }
  if (type === AUserTypes.SaasCompanyUser) {
    if (!isSaaSCompanyUserOnboarding) {
      return <Navigate replace to={"/dashboard"} />
    }
    if (isOnboardingStatusPending) {
      return <Loading size={"xl"} />
    }
    const isOnboardingComplete =
      onboardingStatus?.managed_prospects &&
      onboardingStatus?.used_klara_ai &&
      onboardingStatus?.visited_sales_intelligence
    return <Navigate replace to={isOnboardingComplete ? "/dashboard" : "/onboarding"} />
  }
  if (type === AUserTypes.Admin) {
    return <Navigate replace to={"/admin"} />
  }
  return <Navigate replace to={"/log-in"} />
}

export default Landing
